var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 9.58317C9.4473 9.58317 8.9174 9.36368 8.5267 8.97298C8.136 8.58227 7.9165 8.05237 7.9165 7.49984C7.9165 6.9473 8.136 6.4174 8.5267 6.0267C8.9174 5.636 9.4473 5.4165 9.99984 5.4165C10.5524 5.4165 11.0823 5.636 11.473 6.0267C11.8637 6.4174 12.0832 6.9473 12.0832 7.49984C12.0832 7.77342 12.0293 8.04433 11.9246 8.29709C11.8199 8.54986 11.6664 8.77952 11.473 8.97298C11.2795 9.16643 11.0499 9.31989 10.7971 9.42459C10.5443 9.52928 10.2734 9.58317 9.99984 9.58317ZM9.99984 1.6665C8.45274 1.6665 6.96901 2.28109 5.87505 3.37505C4.78109 4.46901 4.1665 5.95274 4.1665 7.49984C4.1665 11.8748 9.99984 18.3332 9.99984 18.3332C9.99984 18.3332 15.8332 11.8748 15.8332 7.49984C15.8332 5.95274 15.2186 4.46901 14.1246 3.37505C13.0307 2.28109 11.5469 1.6665 9.99984 1.6665Z",
    fill: "#E4441C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.9c1cd1f263928c2fccea7685df51a7a2.svg";
export { ForwardRef as ReactComponent };